import React from "react";
import { Button } from 'devextreme-react/button';
import { useDispatch, useSelector} from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo, faDownload } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import { convertToLocalTime } from "../../commonFunctions/commonFunctions";
import DOMPurify from 'dompurify';

function Comment(props) {
  const { message, date, agent, state, showCommentInfo = true, files } = props;

  return (
    <div>
      {(files != null && files.length > 0) && (
        <div className="firmaHistorico firmaHistoricoFiles">
          <div>
            {files.map(f=>
              <div key={f.caseTraceFileId} onClick={e => props.downloadFile(f.blobFileGuid)}>
                <FontAwesomeIcon icon={faDownload} transform={{ size: 13 }} />
                {f.fileName}
              </div>
              )}
          </div>
          <hr></hr>
        </div>
      )}
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }} />
      {showCommentInfo && (
        <div className="firmaHistorico">
          <hr></hr>
          <FontAwesomeIcon icon={faInfo} transform={{ size: 13 }} />
          <span>
            {dayjs(convertToLocalTime(date)).format("DD/MM/YYYY HH:mm")}
          </span>{" "}
          - <span className="agent-name">{agent}</span>
          <span> - {state}</span>
        </div>
      )}
    </div>
  );
}

export { Comment };
